import(/* webpackMode: "eager" */ "/vercel/path0/src/app/politica-de-privacidade/page.tsx");
